module.exports = __webpack_public_path__ + "media/images/pixabay_logo-97bc8187.svg";